import styled from 'styled-components'

export const ContactContainer = styled.div`
    height : auto;
    display : flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #010606;
`

export const ContactWrapper = styled.div`
    max-width: auto;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    grid-gap: 16px;
    padding: 0 50px;
    height: auto;

    @media screen and (max-width: 1000px){
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px){
        grid-template-columns: 1fr;
        padding: 0 40px;
    }
`

export const ContactCard = styled.div`
    background: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    max-height: 340px;
    max-width: 300px;
    padding: 30px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
    transition: all 0.2s ease-in-out;

    &:hover{
        transform: scale(1.02);
        transition: all 0.2 ease-in-out;
        cursor: pointer;
    }
`

export const ContactIcon = styled.img`
    height: 160px;
    width: 160px;
    margin-bottom: 10px;
`

export const ContactH1 = styled.h1`
    font-size: 2rem;
    color: #fff;
    margin-top: 84px;
    margin-bottom: 54px;

    @media screen and (max-width: 480px){
        font-size: 2rem;
    }
`
export const ContactH3 = styled.h3`
    font-size: 1.5rem;
    color: #fff;
    margin-bottom: 64px;
    margin-top: 64px;


    @media screen and (max-width: 480px){
        font-size: 1rem;
    }
`

export const ContactH2 = styled.h2`
    font-size: 1rem;
    margin-bottom: 10px;
`
export const ContactP = styled.p`
    font-size: 1rem;
    text-align: center;
`